import React, { useState, useEffect, useContext } from 'react'
import { SubOrden } from './SubOrden'
import { Button, Checkbox, Label, LabelDetail, Container, Form, Message } from 'semantic-ui-react'
import AlmDropdown from '../../../componentes/AlmDropdown'
import { AuthContext } from '../../../Auth'
import { getCompanyCollection, getCompanyDocument } from '../../../firebase'

export const NuevaOrdenCompra = ({ onSave }) => {
    const { currentUser } = useContext(AuthContext)
    const [subOrders, setSubOrders] = useState([])
    const [options, setOptions] = useState([])
    const [urgente, setUrgente] = useState([])
    const [color, setColor] = useState([])
    const [message, setMessage] = useState('')
    const [button, setButton] = useState(true)
    const [almacen, setAlmacen] = useState('')
    const [almPrincipal, setAlmPrincipal] = useState('')
    
    useEffect(() => {
        fetchProducts()
        fetchAlmPrincipal()
    }, [])

    useEffect(() => {
        if (!almacen) {
            setMessage("Seleccione el almacén")
            setButton(true)
        } else if (almacen === almPrincipal ) {
            setMessage("El almacén de origen y destino tienen que ser distintos.")
            setButton(true)
        } else if (subOrders.length < 1 ) {
            setMessage("Seleccione el producto.")
            setButton(true)
        } else {
            setMessage('')
            setButton(false)
        }
    }, [almacen, almPrincipal, subOrders])

    const fetchAlmPrincipal = async () => {
        const company = await getCompanyDocument()
        await company.get().then((doc) => {
            if (doc.exists) {
				setAlmPrincipal(doc.data().almPrincipal)
			} else {
				console.log('No hay almacen principal');
			}
        
        }).catch((error) => {
            console.log('Error getting document:', error);
        })
    }

    const fetchProducts = async () => {
        const tempOptions = []
        const productCollection = await getCompanyCollection('Productos')
        const products = (await productCollection.orderBy('clave', 'asc').get()).docs
        for (const product of products) {
            tempOptions.push({
                key: product.id,
                value: product.id,
                text: product.data().nombre,
                unidades: product.data().unidades,
            })
        }
        setOptions(tempOptions)
    }
    const AddSubOrder = () => {
        const tempSubOrders = [...subOrders]
        tempSubOrders.push({
            product: '',
            quantity: 0,
            units: '',
            status: 'solicitado',
        })
        setSubOrders(tempSubOrders)
    }
    const handleChange = (index, subOrder) => {
        const tempSubOrders = [...subOrders]
        tempSubOrders[index] = subOrder
        setSubOrders(tempSubOrders)
    }
    const handleSubmit = async () => {
        const orders = await getCompanyCollection('OrdenCompra')
        await orders.add({
            requestedBy: currentUser.name,
            requestedTo: almacen,
            products: subOrders,
            status: 'pendingApproval',
            pendientes: subOrders.length,
            urgente: urgente,
            tipo: "producto",
            fechaCreado: new Date(),
        }).then(()=>{ onSave() })
    }
    const urgenteCheckbox =(e,{checked})=>{
        setUrgente(checked)
        if (checked === true){
            setColor("orangered")
        } else{
            setColor()
        }
    }
    const handleAlmacenChange = (event, { value }) => {
		setAlmacen(value)
	};
    return (
        <Form style={{backgroundColor: color}}>
            <Container textAlign='right'>
                <Checkbox 
                    toggle label='Es URGENTE?' 
                    onChange={urgenteCheckbox}
                    />
            </Container>
            <Container>
                <Label horizontal>
                    Enviar a:
                    <LabelDetail>
                        <AlmDropdown 
                            placeholder='almacén'
                            value={almacen} 
                            onChange={handleAlmacenChange}
                            excluir={almPrincipal}
                            all={1} 
                            />
                    </LabelDetail>
                </Label>
            </Container>
            <Container textAlign='center'>
                <Button 
                    icon='add' 
                    onClick={AddSubOrder}
                    content='Producto'
                    />
            </Container>
            {subOrders.map((subOrder, i) => {
                return (
                    <SubOrden
                    key ={i}
                    index={i}
                    options={options}
                    handleChange={handleChange}
                    />
                )
            })}
            {message?<Message>{message}</Message>:null}
            <Button onClick={handleSubmit} disabled={button} type='submit'>Crear</Button>
        </Form>
    )
}
